import { useSelector } from "react-redux";
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, ResponsiveContainer } from "recharts";

import { Tooltip } from "./Tooltip";
import { TooltipContent } from "./TooltipContent";
import { currencyFormatter } from "../../services";

export const maxValue = (dataMax) => {
  dataMax = dataMax.toFixed() === "0" ? 1 : dataMax.toFixed();
  const length = dataMax.toString().length - 1;
  const a = Math.round(dataMax / 10 ** length);
  return 2 * a * 10 ** length;
};

export const DoubleBarChart = ({
  children,
  data,
  bars,
  horizontal,
  vertical,
  hideYAxis,
  margin,
  hideXAxis,
  xAxisTickLine,
  xAxisStroke,
  xAxisStrokeWidth,
  hideSum,
  tickFormatter,
}) => {
  const { user } = useSelector((state) => state.auth);
  return (
    <ResponsiveContainer width="100%" height="100%">
      <BarChart width={500} height={300} data={data} margin={margin}>
        <Tooltip chartData={data} content={<TooltipContent hideSum={hideSum} />} />
        <CartesianGrid vertical={vertical} horizontal={horizontal} strokeDasharray="3 3" />
        <XAxis
          hide={hideXAxis}
          dataKey="name"
          tickLine={xAxisTickLine}
          stroke={xAxisStroke}
          strokeWidth={xAxisStrokeWidth}
          dy={10}
        />
        <YAxis
          hide={hideYAxis}
          tickLine={false}
          axisLine={false}
          domain={[0, maxValue]}
          tickFormatter={tickFormatter}
        />
        {bars.map((bar, i) => (
          <Bar
            key={i}
            dataKey={bar.dataKey}
            fill={bar.fill}
            barSize={bar.barSize || 12}
            unit={bar.unit === "sqft" ? user?.unit_system : bar.unit}
          />
        ))}
        {children}
      </BarChart>
    </ResponsiveContainer>
  );
};

DoubleBarChart.defaultProps = {
  vertical: true,
  horizontal: true,
  hideYAxis: false,
  hideXAxis: false,
  xAxisTickLine: false,
  xAxisStrokeWidth: 1,
  tickFormatter: currencyFormatter,
};
